import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Roster } from "@app/models/rest/roster/roster";
import { RosterRestService } from "@app/services/hal/roster/roster-rest-service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class RosterStore extends RealTimeDataStore<Roster> {
  constructor() {
    const rosterRestService = inject(RosterRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(rosterRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Roster");
  }
}
